













import { computed, defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useUserTags from "@/hooks/useUserTags";
import { $t } from "@/lib/i18nHelpers";
import ModalView from "@/components/ModalView";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "SelectUserTagsModal",
  components: { TagsController, ModalView },
  props: {
    value: { type: Boolean, required: true },
    title: { type: String as PropType<TranslateResult>, default: $t("Categories") },
    tagsType: { type: String as () => TagInfoType, required: true },
  },
  setup(props, { emit }) {
    const {
      userTags,
      userContentTypes,
      userTagsUpdateData,
      userContentTypesUpdateData,
      userTagsGetData,
    } = useUserTags();

    const updateData = props.tagsType === TagInfoType.USERS ? userTagsUpdateData : userContentTypesUpdateData;

    const tagsIds = computed(() => (props.tagsType === TagInfoType.USERS ? userTags.value : userContentTypes.value));

    const getData = async () => {
      await userTagsGetData();
    };

    const save = async (tags: TagInfo[], cb?: Function) => {
      const tagIds = tags.map(i => i.id);
      try {
        await updateData(tagIds);
        emit("save", tagIds);
      } finally {
        cb && cb();
      }
    };

    getData();

    return {
      tagsIds,
      save,
    };
  },
});
